import { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AdminSessionProvider, useAdminSession } from "@/auth/AdminSession";
import SecurityDialogs from "@/auth/SecurityDialogs";
const SessionRoute = ({ children }: { children: ReactElement }) => {
  const { session, tenant, can } = useAdminSession();
  const { pathname } = useLocation();
  if (pathname.startsWith("/platform"))
    return session.is_platform_admin ? children : <Navigate to="/" replace />;
  if (/^\/(account|notifications|organizations)(\/|$)/.test(pathname))
    return children;
  if (!tenant)
    return (
      <Navigate
        to={session.is_platform_admin ? "/platform" : "/organizations"}
        replace
      />
    );
  const required = /^\/jobs\/(create|edit)/.test(pathname)
    ? "jobs.write"
    : /^\/(job-applications|applied-list)/.test(pathname)
      ? "applications.read"
      : /^\/cv-list/.test(pathname)
        ? "candidates.manage"
        : null;
  if (required && !can(required))
    return <div className="p-8">この操作の権限がありません。</div>;
  if (
    pathname === "/jobs/create" &&
    tenant.type === "company" &&
    !session.company_posting
  )
    return (
      <div className="p-8">
        企業の直接求人登録は準備中です。紹介会社に登録をご依頼ください。
      </div>
    );
  if (
    tenant.type === "company" &&
    /^\/(shared-jobs|saved-jobs|applied-list|cv-list)(\/|$)/.test(pathname)
  )
    return <Navigate to="/jobs" replace />;
  return children;
};
export default function ProtectedRoute({
  children,
}: {
  children: ReactElement;
}) {
  if (!localStorage.getItem("token")) return <Navigate to="/login" replace />;
  return (
    <AdminSessionProvider>
      <SecurityDialogs />
      <SessionRoute>{children}</SessionRoute>
    </AdminSessionProvider>
  );
}
